<template>
  <div class="product card" :class="{ opened: showCard }" @mouseenter="getCompositions(); openCard();" @mouseleave="closeCard()">
    <a :href="product.detail_link" class="card-img">
      <product-image :src="product.image" :thumb="product.thumb" :link="product.detail_link" :alt="product.name"></product-image>

      <product-tag v-if="product.is_discounted" name="discount" :text="`-${product.discount}%`"></product-tag>
      <product-tag v-else-if="product.is_new" name="new" :text="$t('general.singleProduct.new')"></product-tag>
      <div class="icon icon-eye-1 icon-right" :class="{ 'd-none': showCard }" @click.prevent="openCard()"></div>
      <div class="card-img-overlay align-items-center justify-content-center">
        <div class="overlay-content text-center">
          <div class="icon icon-close icon-right d-block d-lg-none" @click.prevent="closeCard()"></div>
          <favorites-button :pid="product.id"></favorites-button>
          <add-to-cart-just-button :product="product"></add-to-cart-just-button>
          <div class="dataContainer mt-1 mt-sm-3" v-if="!isSewingMachine && compositions !== null">
            <table class="w-100 text-left">
              <template v-for="(composition, index) in compositions">
                <tr v-if="(index < 2 && compositions.length > 3) || compositions.length <= 3" :key="composition.id">
                  <td width="60px">{{ composition.part }} %</td>
                  <td>{{composition.title}}</td>
                </tr>
              </template>
              <tr v-if="compositions.length > 3">
                <td></td>
                <td>anderes</td>
              </tr>
            </table>
          </div>
          <hr class="dataContainer" v-if="!isSewingMachine && compositions !== null">
          <div class="dataContainer mt-1 mt-sm-3" v-if="!isSewingMachine">
            <table class="w-100 text-left">
                <tr v-if="product.width > 0">
                    <td width="60px">{{$t('product.properties.info.width')}}:</td>
                    <td>{{ product.width }} cm</td>
                </tr>
                <tr v-if="product.step > 0.1 && product.unit == 'm'">
                    <td width="60px">{{$t('product.properties.info.raport')}}:</td>
                    <td>{{ product.step * 100 }} cm</td>
                </tr>
                <tr v-if="product.weight">
                    <td width="60px">{{$t('product.properties.info.weight')}}:</td>
                    <td>{{ product.weight }} g/m2</td>
                </tr>
            </table>
          </div>
          <div class="dataContainer2 mt-3 mt-sm-3" v-if="isSewingMachine">
            {{ product.short_description }}
          </div>
        </div>
      </div>
    </a>
    <div class="card-body">
      <a :href="product.detail_link">{{ product.name }}</a>
    </div>
    <div class="card-footer clearfix">
      {{$t('general.singleProduct.price')}}:
      <template v-if="product.is_discounted">
        <span class="text-line-through d-none d-sm-inline">
          {{ product.brutto_price | money }}/{{ product.unit }}
        </span>
        <span class="float-right text-salmon-strong d-inline d-sm-none">
          {{ product.price | money }}/{{ product.unit }}
        </span>
        <span class="float-right  d-none d-sm-inline">
          {{ product.price | money }}/{{ product.unit }}
        </span>
      </template>
      <span v-else class="float-right">
        {{ product.price | money }}/{{ product.unit }}
      </span>
    </div>
  </div>
</template>
<script>
import xhr from '@Core/xhr'
import FavoritesButton from '@Components/favorites-button/FavoritesButton'
import AddToCartJustButton from '@Components/basket/AddToCartJustButton'
import ProductImage from './ProductImage'
import ProductTag from './ProductTag'

export default {
  props: {
    product: {
      required: true
    }
  },

  data () {
    return {
      compositions: null,
      isSewingMachine: false,
      showCard: false
    }
  },

  components: {
    FavoritesButton,
    ProductImage,
    ProductTag,
    AddToCartJustButton,
  },

  methods: {
    getCompositions() {
      if(this.compositions === null) {
        let request = new xhr()
        request.get(`/product/compositions/${this.product.id}`).then((response) => {
          this.compositions = response.compositions
          this.isSewingMachine = response.isSewingMachine
        });
      }
    },

    openCard() {
      setTimeout(() => {
        this.showCard = true;
      }, 1)
    },

    closeCard() {
      this.showCard = false;
    }
  },

  filters: {
    money: function (value) {
      return parseFloat(value).toFixed(2).replace('.', ',') + ' €'
    }
  }
}
</script>
